// extracted by mini-css-extract-plugin
export default {"query-suggestion-item":"Nx61rW0BDf85WwLqn1gS ZTB8V4Ekne5ik0yyepWH"};